<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

      <!--  ROW    -->
      <div v-if="!loading" class="vx-row mb-1" style="max-height: 550px;overflow: scroll;">
        <div class="vx-col  w-full">
          <template
            v-for="(localization, index) in workingLocalizations" :index="index">
            <div class="vx-row" :key="index">
              <div class="vx-col mb-5 pb-4 w-full">
                <vs-divider class="my-0" position="center" color="primary">{{ getLanguageNameAndCode(localization.language_id) }}</vs-divider>
                <!--        This is kindof a weird hack to get the default name and description showing up as english even though it isn't technically correct (per Matt's request)        -->
<!--                <div v-if="localization.language_id === 1 && !localization.name && (localization.name = helpers.getPreferredName(category))"></div>-->
<!--                <div v-if="localization.language_id === 1 && !localization.description && (localization.description = helpers.getPreferredDescription(category))"></div>-->

                <vs-input
                  class="w-full mb-1"
                  label="Name"
                  v-model="localization.name"
                />
                <vs-textarea
                  class="w-full mb-1"
                  label="Short Description"
                  v-model="localization.free_description"
                />
                <vs-textarea
                  class="w-full mb-1"
                  label="Long Description"
                  v-model="localization.description"
                />

              </div>
            </div>
          </template>

        </div>
      </div>

      <div class="vx-row" v-if="isModified">
        <div class="vx-col w-full mb-2">
          <vs-button class="mx-1 w-full" @click="saveChanges">Save Changes</vs-button>
        </div>
      </div>

    </div>


</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import api from '@/http/api';
  import {cyclopediaAnalysisCategoryHelpers} from '@/models/helpers'

  export default {
    // mixins: [
    //   ContainerMixin,
    //   ElementMixin
    // ],
    data() {
      return {
        loading: false,
        jsonHtml: jsonHtml,
        showNewRankDialog: false,
        helpers: cyclopediaAnalysisCategoryHelpers,
        languages: [new types.Language()],
        originalLocalizations: [new types.CyclopediaAnalysisCategoryLocalization()],
        workingLocalizations: [new types.CyclopediaAnalysisCategoryLocalization()],
      }
    },
    props: {
      category: {
        type: types.CyclopediaAnalysisCategory(),
        required: true,
        default: () => {
          return new types.CyclopediaAnalysisCategory()
        }
      },
    },
    watch: {
      // rank: function (newVal, oldVal) {
      //   if (JSON.stringify(newVal.ranks) === JSON.stringify(oldVal.ranks)) return;
      //   this.setRankCopies(newVal.ranks);
      // },
    },
    mounted() {
      this.fetchLanguages();
    },
    computed: {
      isModified() {
        return JSON.stringify(this.workingLocalizations) !== JSON.stringify(this.originalLocalizations);
      }
    },
    methods: {
      async fetchLanguages() {
        this.loading = true;
        this.languages = await api.fetchAllLanguages();
        this.buildWorkingLocalizations();
        this.loading = false;
      },
      getLanguageNameAndCode(id) {
        try {
          const lang = this.languages.filter((l) => l.language_id === id)[0];
          return `${lang.name} (${lang.code}-${lang.country || ''})`;
        } catch (e) {
          return '?';
        }
      },
      buildWorkingLocalizations() {
        if (!this.category) return;
        this.workingLocalizations = [];
        this.languages.forEach((lang) => {
          let localization = this.helpers.getLocalization(this.category, lang.language_id, this.category.id);
          if (localization.language_id === 1 && !localization.name && !localization.description) {
            localization.name = this.helpers.getPreferredName(this.category);
            localization.description = this.helpers.getPreferredDescription(this.category);
          }
          this.workingLocalizations.push(localization)
        });
        this.originalLocalizations = JSON.parse(JSON.stringify(this.workingLocalizations));
      },
      async saveChanges() {
        if (!this.isModified) return;
        this.loading = true;

        let localizationsToSave = [];
        this.languages.forEach((lang)=> {
          // only save if the name has changed
          const original = this.helpers.getLocalizationFromList(this.originalLocalizations, lang.language_id, this.category.id);
          const modified = this.helpers.getLocalizationFromList(this.workingLocalizations, lang.language_id, this.category.id);
          if (original.name !== modified.name || original.description !== modified.description || original.free_description !== modified.free_description) {
            // if (!modified.free_description) {
            //   modified.free_description = '';
            // }
            localizationsToSave.push(modified);
          }
        });

        let newCategory = await api.putAnalysisCategoryLocalizations(this.category, localizationsToSave);
        if (newCategory) {
          newCategory = await api.fetchLeanAnalysisCategory(this.category);
        }
        if (newCategory) {
          this.showNotification(true, 'Localizations updated');
        } else {
          this.showNotification(false, 'Error updating localizations');
        }

        this.$emit('categoryUpdated', newCategory);

        this.loading = false;

      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
